import { render, staticRenderFns } from "./schoolcontent.vue?vue&type=template&id=4cac8314&scoped=true"
import script from "./schoolcontent.vue?vue&type=script&lang=js"
export * from "./schoolcontent.vue?vue&type=script&lang=js"
import style0 from "./schoolcontent.vue?vue&type=style&index=0&id=4cac8314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac8314",
  null
  
)

export default component.exports